module.exports = [
    'abstractNote',
    'language',
    'bookTitle',
    'series',
    'seriesNumber',
    'numberOfVolumes',
    'place',
    'ISBN',
    'accessDate',
    'libraryCatalog',
    'callNumber',
    'shortTitle',
    // Creator Types
    'contributor',
    'seriesEditor',
    'bookAuthor'

]


//////////////////
// WEBPACK FOOTER
// ./static/blacklists/mlaBook.js
// module id = bh+1
// module chunks = 1